import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import { camelCase } from "lodash";
import "flatpickr/dist/flatpickr.css";
import { seo } from "@/mixins/seo";
import { English } from "flatpickr/dist/l10n/uk";
import { isRenewalWindowOpen } from "@/utils/renewalWindow";

import HeadFilter from "@/components/features/head-filter/index.vue";
import TooltipLayout from "@/components/atoms/tooltip-layout/index.vue";
import BtnLoadMore from "@/components/atoms/buttons/load-more/index.vue";
import VueFlatPickr from "vue-flatpickr-component";

export default {
	name    : "profile-payments-history",
	mixins  : [seo],
	data() {
		return {
			//list			: [],
			isMobile        : false,
			payload         : {
				dateFrom: "",
				dateTo  : ""
			},
			config          : {
				altFormat   : "j M, Y",
				altInput    : true,
				start       : {
					minDate         : null,
					maxDate         : null,
					locale          : English,
					disableMobile   : "true"
				},
				end         : {
					minDate         : null,
					locale          : English,
					disableMobile   : "true"
				},
			},
			dummyUserTariff : []
		};
	},
	components: {
		HeadFilter,
		"date-picker": VueFlatPickr,
		TooltipLayout,
		BtnLoadMore,
	},
	created() {
		//this.seo.title = this.$t(camelCase(this.$route.name));
		this.seo.title = this.$t("profilePaymentsHistory");
		
		if (!this.list.length) {
			this.fetchList(this.payload);
		}
		
		if (!this.userTariff.length) {
			this.fetchUserTariff(this.payload);
		}
		
		this.fetchCardsList();
	},
	mounted() {
		this.onResize();
		
		window.addEventListener("resize", this.onResize, { passive: true });
	},
	computed: {
		...mapGetters({
			userTariff          : `user/userTariff`,
			userTariffLoading   : `user/userTariffLoading`,
			cardsList           : "userPayments/cardsList",
			user                : "user/user",
			list                : "userPaymentsHistory/list",
			listLength          : "userPaymentsHistory/listLength",
			isListLoading       : "userPaymentsHistory/isListLoading",
			listLimit           : "userPaymentsHistory/limit"
		}),
	},
	methods: {
		...mapActions({
			fetchUserTariff : "user/GET_USER_TARIFF",
			fetchCardsList  : "userPayments/GET_CARDS_LIST",
			fetchList       : "userPaymentsHistory/GET_LIST",
			deleteTariff    : "user/DELETE_USER_TARIFF",
			
			continuePay		: "userPaymentsHistory/CONTINUE_PAY",
		}),
		...mapMutations({
			setCategories   					: "education/SET_CATEGORIES",
			changeSkip      					: "userPaymentsHistory/CHANGE_SKIP",
			setList         					: "userPaymentsHistory/SET_LIST",
			changeShowPopupCancelSubscription	: "userPaymentsHistory/CHANGE_POPUP_CANCEL_SUBSCRIPTION",
			changeShowPopupUpdateSubscription	: "userPaymentsHistory/CHANGE_POPUP_UPDATE_SUBSCRIPTION",
		}),
		onStartChange(selectedDates, dateStr) {
			this.$set(this.config.end, "minDate", dateStr);
			this.payload.dateFrom = dateStr;
			this.changeSkip(false);
			this.setList([]);
			this.fetchList(this.payload);
		},
		onEndChange(selectedDates, dateStr) {
			this.$set(this.config.start, "maxDate", dateStr);
			this.payload.dateTo = dateStr;
			this.changeSkip(false);
			this.setList([]);
			this.fetchList(this.payload);
		},
		changeLazyBtn() {
			this.changeSkip();
			this.fetchList(this.payload);
		},
		onResize() {
			this.isMobile = window.innerWidth < 900;
		},
		deleteTariffLocal(data) {
			if(data.isConnected){
				this.changeShowPopupCancelSubscription([true, data]);
			}
		},
		connectTariffLocal(data){
			if(data.isRenewable && this.renewalWindowOpen()){
				this.changeShowPopupUpdateSubscription([true, data]);
			}
		},
		// Renewal buttons are shown only during the annual sales window (07–27.12)
		renewalWindowOpen() {
			return isRenewalWindowOpen();
		},
		calculateExpiredDate(item) {
			const { activeTo } = item;
			
			if (!activeTo) {
				return "∞";
			}
			
			return moment(activeTo).format("DD.MM.YYYY");
		},
		getItemDate(item) {
			if(!item.createdAt){
				return '';
			}
			
			let arr = item.createdAt.split(" ");
			
			return moment(arr[0]).format("DD.MM.YY");
		},
		getItemTime(item) {
			if(!item.createdAt){
				return '';
			}
			
			let arr = item.createdAt.split(" ");
			
			return arr[1].slice(0, 5);
		},
		async setContinue(item) {
			if(item.wait === true){
				return false;
			}
			
			item.wait		= true;
			item.loading	= true;
			
			const response = await this.continuePay(item);
			
			if(response && response.id){
				this.$toasted.success(this.$t("successContinue"));
				
				setTimeout(() => {
					this.fetchUserTariff(this.payload);
				}, 15000);
			}else{
				this.$toasted.error(this.$t("failedContinue"));
			}
		},
		checkContinueDate(item){
			if(item.wait === true){
				return false;
			}
			
			if(
				item.isConnected && 
				(
					item.tariffId == 88 || 
					item.tariffId == 90 || 
					item.tariffId == 94 || 
					item.tariffId == 95 || 
					item.tariffId == 116 || 
					item.tariffId == 117 || 
					item.tariffId == 118 || 
					item.tariffId == 119
				)
			){
				var activeTo = item.activeTo.split(" ")[0]+" 00:00:00";
				
				var date = new Date();
				
				var now_utc = Date.UTC(
					date.getUTCFullYear(), 
					date.getUTCMonth(),
					date.getUTCDate(),
					date.getUTCHours(),
					date.getUTCMinutes(),
					date.getUTCSeconds()
				);
				
				var currectDate = new Date(now_utc).toISOString();
				currectDate = currectDate.replace("T", " ");
				currectDate = currectDate.split(" ")[0]+" 00:00:00";
				
				// Ваши даты
				const date1 = new Date(activeTo);
				const date2 = new Date(currectDate);
				
				// Вычисление разницы в миллисекундах
				const diffInMs = Math.abs(date2.getTime() - date1.getTime());
				
				// Преобразование разницы в дни
				const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
				
				//console.log(`Разница между датами: ${diffInDays} дней`);
				
				if(diffInDays >= 0 && diffInDays <= 30){
					return true;
				}
			}
			
			return false;
		},
		getDays(item){
			var activeTo = item.activeTo.split(" ")[0]+" 00:00:00";
			
			var date = new Date();
			
			var now_utc = Date.UTC(
				date.getUTCFullYear(), 
				date.getUTCMonth(),
				date.getUTCDate(),
				date.getUTCHours(),
				date.getUTCMinutes(),
				date.getUTCSeconds()
			);
			
			var currectDate = new Date(now_utc).toISOString();
			currectDate = currectDate.replace("T", " ");
			currectDate = currectDate.split(" ")[0]+" 00:00:00";
			
			// Ваши даты
			const date1 = new Date(activeTo);
			const date2 = new Date(currectDate);
			
			if(date1 < date2){
				return 0;
			}
			
			// Вычисление разницы в миллисекундах
			const diffInMs = Math.abs(date2.getTime() - date1.getTime());
			
			// Преобразование разницы в дни
			const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
			
			return diffInDays;
		},
		toCamelCase(str) {
			return camelCase(str);
		},
		checkPay(item){
			console.log('checkPay:', item);
			
			if(item.payment && item.payment.data && ('id' in item.payment.data)){
				return true;
			}
			
			return false;
		},
		checkNotPay(item){
			if(!item.payment){
				return true;
			}
			
			if(!item.payment.data){
				return true;
			}
			
			if(!('id' in item.payment.data)){
				return true;
			}
			
			return false;
		}
	},
	destroyed() {
		this.setList([]);
	},
};
